import { useState } from "react";
import {useNavigate} from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { useLogout } from "./hooks/useLogout";
import { useAuthContext } from "./hooks/useAuthContext";
import PasswordModal from "./PasswordModal";

function BasicNavbar(props) {
  const { logout } = useLogout();
  const { user } = useAuthContext();
  const [showModal, setShowModal] = useState(false);

  const navigate = useNavigate();

  const handleClick = () => {
    logout();
    navigate("/login");
  };

  async function handleReset(e) {
    e.preventDefault();
    setShowModal(true);
  }

  return (
    <Navbar bg={props.theme} expand="lg" className={`navbar-${props.theme}`}>
      <Navbar.Brand href="/">CCC - Streck</Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="me-auto">
          {user && (<>
            <Nav.Link disabled={true}>{user.username.toUpperCase()}</Nav.Link>
            <Nav.Link href="/stats">Statistik</Nav.Link>
            <Nav.Link onClick={handleClick}>Logga ut</Nav.Link>
          </>)}
          {!user && (
            <>
              <Nav.Link href="/login">Logga in</Nav.Link>
            </>
          )}
        </Nav>
      </Navbar.Collapse>
        <Navbar.Collapse className="justify-content-end">
          <Nav >
            <Nav.Link>
            {props.darkModeToggle}
            </Nav.Link>
      {user && user.role === "admin" && (<>
            <Nav.Link className="a-nav-reset-link" onClick={handleReset}>
              Återställ databasen
            </Nav.Link>
            </>)}
          </Nav>

        </Navbar.Collapse>
      <PasswordModal show={showModal} onHide={() => setShowModal(false)}></PasswordModal>
    </Navbar>
  );
}

export default BasicNavbar;
